export const settings = `
<div style="display:flex; flex-direction:column; height:100vh; width: 100%; padding-left:2.5rem; padding-right:2.5rem; box-sizing:border-box;">
    <div style="height: 1rem;"></div>
    <div class="react-loading-skeleton"
      style=" width:10%;height:1rem;"></div>
    <div class="react-loading-skeleton"
      style="width:25%; height:1.5rem; margin-top:0.75rem;"></div>
    <div style="display:flex; flex-direction:row; justify-content: flex-start; width: 100%; margin-top:1.25rem;height:5%; gap:0.5rem;">
      <div class="react-loading-skeleton" style="width:40%;"></div>
      <div class="react-loading-skeleton"
         style="width:9%; height:67%; align-self:flex-end; margin-left: auto; margin-right: 1rem;"></div>
      <div class="react-loading-skeleton"
         style="width:9%; height:67%; align-self:flex-end; margin-right: 1rem;"></div>
    </div>
    <div 
      style="display:flex; flex-direction:row; justify-content: flex-start; width: 100%; border-top:1px solid #D8D8D8; border-bottom:1px solid #D8D8D8; align-items: center;height:7%; margin-top:0.75rem; margin-bottom:1.5rem;">
      <div class="react-loading-skeleton"
         style=" width:34%; height:60%;"></div>
    </div>
    <div class="react-loading-skeleton" style="height:4%;"></div>
    <div style="display: grid; grid-template-columns: 4fr 2fr 2fr 2fr 2fr 2fr; width: 100%; height: 7%; align-items: center; border-bottom: 1px solid #DDDDDD;">
      <div class="react-loading-skeleton" style="width: 410px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div style="display: flex; justify-content: flex-end; gap:0.75rem">
        <div class="react-loading-skeleton" style="width: 75px; height: 36px;"></div>
        <div class="react-loading-skeleton" style="width: 32px; height: 36px;"></div>
      </div>
    </div>
    <div style="display: grid; grid-template-columns: 4fr 2fr 2fr 2fr 2fr 2fr; width: 100%; height: 7%; align-items: center; border-bottom: 1px solid #DDDDDD;">
      <div class="react-loading-skeleton" style="width: 410px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div style="display: flex; justify-content: flex-end; gap:0.75rem">
        <div class="react-loading-skeleton" style="width: 75px; height: 36px;"></div>
        <div class="react-loading-skeleton" style="width: 32px; height: 36px;"></div>
      </div>
    </div>
    <div style="display: grid; grid-template-columns: 4fr 2fr 2fr 2fr 2fr 2fr; width: 100%; height: 7%; align-items: center; border-bottom: 1px solid #DDDDDD;">
      <div class="react-loading-skeleton" style="width: 410px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div style="display: flex; justify-content: flex-end; gap:0.75rem">
        <div class="react-loading-skeleton" style="width: 75px; height: 36px;"></div>
        <div class="react-loading-skeleton" style="width: 32px; height: 36px;"></div>
      </div>
    </div>
    <div style="display: grid; grid-template-columns: 4fr 2fr 2fr 2fr 2fr 2fr; width: 100%; height: 7%; align-items: center; border-bottom: 1px solid #DDDDDD;">
      <div class="react-loading-skeleton" style="width: 410px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div style="display: flex; justify-content: flex-end; gap:0.75rem">
        <div class="react-loading-skeleton" style="width: 75px; height: 36px;"></div>
        <div class="react-loading-skeleton" style="width: 32px; height: 36px;"></div>
      </div>
    </div>
    <div style="display: grid; grid-template-columns: 4fr 2fr 2fr 2fr 2fr 2fr; width: 100%; height: 7%; align-items: center; border-bottom: 1px solid #DDDDDD;">
      <div class="react-loading-skeleton" style="width: 410px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div style="display: flex; justify-content: flex-end; gap:0.75rem">
        <div class="react-loading-skeleton" style="width: 75px; height: 36px;"></div>
        <div class="react-loading-skeleton" style="width: 32px; height: 36px;"></div>
      </div>
    </div>
    <div style="display: grid; grid-template-columns: 4fr 2fr 2fr 2fr 2fr 2fr; width: 100%; height: 7%; align-items: center; border-bottom: 1px solid #DDDDDD;">
      <div class="react-loading-skeleton" style="width: 410px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div style="display: flex; justify-content: flex-end; gap:0.75rem">
        <div class="react-loading-skeleton" style="width: 75px; height: 36px;"></div>
        <div class="react-loading-skeleton" style="width: 32px; height: 36px;"></div>
      </div>
    </div>
    <div style="display: grid; grid-template-columns: 4fr 2fr 2fr 2fr 2fr 2fr; width: 100%; height: 7%; align-items: center; border-bottom: 1px solid #DDDDDD;">
      <div class="react-loading-skeleton" style="width: 410px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div style="display: flex; justify-content: flex-end; gap:0.75rem">
        <div class="react-loading-skeleton" style="width: 75px; height: 36px;"></div>
        <div class="react-loading-skeleton" style="width: 32px; height: 36px;"></div>
      </div>
    </div>
    <div style="display: grid; grid-template-columns: 4fr 2fr 2fr 2fr 2fr 2fr; width: 100%; height: 7%; align-items: center; border-bottom: 1px solid #DDDDDD;">
      <div class="react-loading-skeleton" style="width: 410px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div class="react-loading-skeleton" style="width: 180px; height: 36px;"></div>
      <div style="display: flex; justify-content: flex-end; gap:0.75rem">
        <div class="react-loading-skeleton" style="width: 75px; height: 36px;"></div>
        <div class="react-loading-skeleton" style="width: 32px; height: 36px;"></div>
      </div>
    </div>
       <div class="react-loading-skeleton"
          style="margin-top:0.5rem; width:30%; height:5%; align-self:center;"></div>
    </div>
`;
